var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.445 10.305h-4.199V6.816c0-1.067-.904-1.935-2.016-1.935h-3.633V1.935C22.597.868 21.693 0 20.581 0H2.016C.904 0 0 .868 0 1.935V19.76c0 1.067.904 1.935 2.016 1.935h3.633v2.946c0 1.067.904 1.935 2.016 1.935h4.199v3.489c0 1.067.904 1.935 2.016 1.935h18.566c1.112 0 2.016-.868 2.016-1.935V12.24c-.001-1.067-.905-1.935-2.016-1.935zM5.649 6.817v13.251H2.016a.315.315 0 01-.321-.308V1.935c0-.17.144-.308.321-.308h18.566c.177 0 .321.138.321.308v2.946H7.665c-1.112 0-2.016.868-2.016 1.935zm6.215 5.423v12.709H7.665a.315.315 0 01-.321-.308V6.816c0-.17.144-.308.321-.308h18.566c.177 0 .321.138.321.308v3.489H13.879c-1.112 0-2.016.868-2.016 1.935zm20.903 17.825c0 .17-.144.308-.321.308H13.88a.315.315 0 01-.321-.308V12.24c0-.17.144-.308.321-.308h18.566c.177 0 .321.138.321.308v17.825z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.5015bbd5d2a24ceb88951958884f2523.svg";
export { ForwardRef as ReactComponent };